export default __webpack_public_path__ + "static/media/private_mansion_blue.bce61ded.svg";